import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { AuthShell } from "./AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link was sent.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("forgot_password")} subtitle="Enter your email to receive a reset link">
      {sent ? (
        <div className="text-center py-4" data-testid="forgot-sent">
          <p className="text-slate-300">Check your inbox for a password reset link.</p>
          <Link to="/login" className="mt-4 inline-block text-brand-cyan hover:underline">{t("nav_login")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label className="text-slate-300">{t("email")}</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1.5 bg-white/5 border-white/10" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full gradient-brand text-brand-navy font-semibold">{loading ? t("loading") : t("submit")}</Button>
          <p className="text-center text-sm text-slate-400"><Link to="/login" className="text-brand-cyan hover:underline">{t("nav_login")}</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
